"use strict";

exports.__esModule = true;
exports.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE = exports.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING = exports.FALLBACK_COLOR_TO_SITE_COLOR_MAPPING = exports.DEFAULT_ADI_CHANNEL = void 0;
var _types = require("./types");
const FALLBACK_COLOR_TO_SITE_COLOR_MAPPING = {
  emptyPlayIconEditor: 'color-4',
  emptyPlayIconSite: 'color-1',
  emptyPlayerBgEditor: 'color-2',
  emptyPlayerBgSite: 'color-2',
  backgroundColor: 'color-1',
  buttonsAndLinksColor: 'color-8',
  mainButtonTextColor: 'color-1',
  textColor: 'color-5',
  dividersAndArrowsColor: 'color-3',
  mobileButtonsTextColor: 'color-1',
  mobileButtonsBackgroundColor: 'color-8',
  mainButtonColor: 'color-8'
};
exports.FALLBACK_COLOR_TO_SITE_COLOR_MAPPING = FALLBACK_COLOR_TO_SITE_COLOR_MAPPING;
const FALLBACK_FONT_TO_TEXT_PRESET_MAPPING = {
  textFont: _types.TextPresetNames.BodyM,
  titleFont: _types.TextPresetNames.HeadingL,
  videoInfoFont: _types.TextPresetNames.HeadingS
};
exports.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING = FALLBACK_FONT_TO_TEXT_PRESET_MAPPING;
const FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE = {
  textFont: _types.TextPresetNames.BodyM,
  titleFont: _types.TextPresetNames.Title,
  videoInfoFont: _types.TextPresetNames.HeadingS
};
exports.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE = FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE;
const DEFAULT_ADI_CHANNEL = '9bf7ba3816de4423963e7d6e23c072e0';
exports.DEFAULT_ADI_CHANNEL = DEFAULT_ADI_CHANNEL;
//# sourceMappingURL=constants.js.map